import { set } from "@/utils/vuex";

export default {
  setAgentInviteData: set("agentInviteData"),
  setRecentlyViewedOpportunities: set("recentlyViewedOpportunities"),
  setRecentlyViewedBrokerages: set("recentlyViewedBrokerages"),
  setRecentlyViewedAgents: set("recentlyViewedAgents"),
  setRecentlyViewedMyAgents: set("recentlyViewedMyAgents"),
};
